import { styled, tooltipClasses } from '@mui/material';
import { Tooltip } from '../Tooltip';
export const TooltipStyled = styled(Tooltip)(({ theme }) => ({
    // Not working for some reason. That's why `sx` below is used.
    [`.${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.info.main,
        [`.${tooltipClasses.arrow}`]: {
            color: theme.palette.info.main,
        },
    },
}));
export const sxTooltip = (theme) => ({
    color: theme.palette.info[900],
    backgroundColor: theme.palette.info.background,
    [`.${tooltipClasses.arrow}`]: {
        color: theme.palette.info.background,
    },
});
